// Styles de l'écran de suivi conformité (palette de la charte : Vert Pétrole, Vert Validation, Crème, Encre, Gris).

const PETROLE = "#0C3B3C";
const VALIDATION = "#17B978";
const ENCRE = "#122A26";
const GRIS = "#5A6D68";
const BORDER = "1px solid #d7e1dc";

const smallButton = {
    minHeight: "28px",
    padding: "4px 8px",
    borderRadius: "6px",
    fontSize: "12px",
};

const cursorFor = disabled => (disabled ? "default" : "pointer");

export const previewStyles = {
    overlay: {
        position: "fixed",
        inset: 0,
        zIndex: 2000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        background: "rgba(15, 23, 42, 0.54)",
    },
    dialog: {
        width: "min(1100px, 96vw)",
        height: "min(820px, 92vh)",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        borderRadius: "8px",
        background: "#ffffff",
        boxShadow: "0 24px 60px rgba(15, 23, 42, 0.32)",
    },
    header: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "12px",
        padding: "12px 14px",
        borderBottom: BORDER,
        background: "#f8faf7",
    },
    title: { minWidth: 0, color: PETROLE, fontSize: "14px", overflowWrap: "anywhere" },
    headerActions: { display: "flex", gap: "8px", flexShrink: 0 },
    download: {
        display: "inline-flex",
        alignItems: "center",
        minHeight: "30px",
        padding: "5px 10px",
        borderRadius: "6px",
        border: `1px solid ${PETROLE}`,
        color: PETROLE,
        textDecoration: "none",
        fontSize: "12px",
        fontWeight: 800,
    },
    close: {
        minHeight: "30px",
        padding: "5px 10px",
        borderRadius: "6px",
        border: `1px solid ${PETROLE}`,
        background: PETROLE,
        color: "#ffffff",
        cursor: "pointer",
        fontSize: "12px",
        fontWeight: 800,
    },
    body: { flex: 1, minHeight: 0, background: "#eef3f0" },
    imageFrame: {
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "14px",
    },
    image: { maxWidth: "100%", maxHeight: "100%", objectFit: "contain" },
    audioFrame: {
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
    },
    audio: { width: "min(680px, 100%)" },
    video: { width: "100%", height: "100%", objectFit: "contain", background: ENCRE },
    inline: { width: "100%", height: "100%", border: 0, background: "#ffffff" },
    unavailable: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "12px",
        padding: "28px",
        textAlign: "center",
        color: ENCRE,
    },
    unavailableTitle: { fontSize: "18px", color: PETROLE },
    unavailableText: { maxWidth: "520px", color: GRIS, lineHeight: 1.5 },
    unavailableDownload: {
        display: "inline-flex",
        alignItems: "center",
        minHeight: "34px",
        padding: "7px 12px",
        borderRadius: "6px",
        border: `1px solid ${PETROLE}`,
        background: "#ffffff",
        color: PETROLE,
        textDecoration: "none",
        fontSize: "13px",
        fontWeight: 800,
    },
};

export const rowStyles = {
    row: {
        display: "grid",
        gridTemplateColumns: "minmax(0, 1fr) auto",
        gap: "8px",
        alignItems: "center",
        padding: "5px 0",
        borderTop: "1px solid #e5ebe8",
    },
    renameForm: { display: "flex", gap: "6px", minWidth: 0 },
    renameInput: {
        minWidth: 0,
        flex: 1,
        minHeight: "28px",
        border: `1px solid ${VALIDATION}`,
        borderRadius: "6px",
        padding: "4px 8px",
        color: ENCRE,
        fontSize: "12px",
        fontWeight: 700,
    },
    confirm: (hasValue, disabled) => ({
        ...smallButton,
        border: `1px solid ${VALIDATION}`,
        background: hasValue ? VALIDATION : "#d7e1dc",
        color: PETROLE,
        cursor: cursorFor(disabled),
        fontWeight: 900,
    }),
    secondary: (busy, color) => ({
        ...smallButton,
        border: BORDER,
        background: "#ffffff",
        color,
        cursor: cursorFor(busy),
        fontWeight: 700,
    }),
    open: {
        border: "none",
        background: "transparent",
        padding: 0,
        color: PETROLE,
        cursor: "pointer",
        fontWeight: 800,
        fontSize: "13px",
        textAlign: "left",
        overflowWrap: "anywhere",
    },
    meta: { display: "block", color: GRIS, fontWeight: 600, fontSize: "12px", marginTop: "3px" },
    actions: { display: "flex", gap: "6px", justifyContent: "flex-end", flexWrap: "wrap" },
    petrole: PETROLE,
    gris: GRIS,
};

export const slotStyles = {
    slot: appearance => ({
        display: "grid",
        gridTemplateColumns: "30px minmax(0, 1.1fr) minmax(0, 1fr) auto",
        gap: "12px",
        alignItems: "start",
        padding: "10px 12px",
        borderTop: BORDER,
        background: appearance.background,
        opacity: appearance.opacity,
    }),
    indicator: appearance => ({
        width: "24px",
        height: "24px",
        borderRadius: "999px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "1px",
        border: appearance.indicatorBorder,
        background: appearance.indicatorBackground,
        color: appearance.indicatorColor,
        fontSize: "15px",
        fontWeight: 900,
        lineHeight: 1,
        flexShrink: 0,
    }),
    column: { minWidth: 0 },
    title: { color: PETROLE, fontSize: "13px", fontWeight: 900, lineHeight: 1.35, overflowWrap: "anywhere" },
    summary: color => ({ color, fontSize: "12px", fontWeight: 700, marginTop: "4px" }),
    documentList: { display: "flex", flexDirection: "column" },
    empty: { color: "#94a3b8", fontSize: "13px", fontWeight: 700, paddingTop: "2px" },
    actionsColumn: { display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "6px" },
    actionsRow: { display: "flex", gap: "6px", flexWrap: "wrap", justifyContent: "flex-end" },
    importLabel: busy => ({
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "30px",
        padding: "5px 9px",
        borderRadius: "6px",
        border: `1px solid ${PETROLE}`,
        background: busy ? "#d7e1dc" : PETROLE,
        color: "white",
        cursor: cursorFor(busy),
        fontSize: "12px",
        fontWeight: 800,
        whiteSpace: "nowrap",
    }),
    hidden: { display: "none" },
    linkToggle: busy => ({
        minHeight: "30px",
        padding: "5px 9px",
        borderRadius: "6px",
        border: `1px solid ${PETROLE}`,
        background: "#ffffff",
        color: PETROLE,
        cursor: cursorFor(busy),
        fontSize: "12px",
        fontWeight: 800,
        whiteSpace: "nowrap",
    }),
    linkForm: { display: "flex", gap: "6px", width: "260px", maxWidth: "100%" },
    linkInput: {
        minWidth: 0,
        flex: 1,
        minHeight: "30px",
        border: BORDER,
        borderRadius: "6px",
        padding: "4px 8px",
        color: ENCRE,
        fontSize: "12px",
    },
    linkConfirm: (hasValue, disabled) => ({
        minHeight: "30px",
        padding: "5px 8px",
        borderRadius: "6px",
        border: `1px solid ${VALIDATION}`,
        background: hasValue ? VALIDATION : "#d7e1dc",
        color: PETROLE,
        cursor: cursorFor(disabled),
        fontSize: "12px",
        fontWeight: 900,
    }),
};

export const folderStyles = {
    section: nested => ({
        border: BORDER,
        borderRadius: "8px",
        background: "#ffffff",
        overflow: "hidden",
        marginTop: nested ? "8px" : 0,
    }),
    header: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "12px",
        padding: "16px 18px",
        borderBottom: `2px solid ${VALIDATION}`,
        background: "#f8faf7",
    },
    nestedTitle: { margin: 0, color: PETROLE, fontSize: "16px" },
    title: { margin: 0, color: PETROLE, fontSize: "18px" },
    body: { padding: "16px 18px", display: "flex", flexDirection: "column", gap: "10px" },
    error: { color: "#b91c1c", fontSize: "13px", fontWeight: 700 },
    loading: { color: GRIS, fontSize: "14px" },
    slots: {
        display: "flex",
        flexDirection: "column",
        border: BORDER,
        borderTop: "none",
        borderRadius: "8px",
        overflow: "hidden",
    },
    noResult: {
        padding: "12px",
        borderTop: BORDER,
        background: "#f8faf7",
        color: GRIS,
        fontSize: "13px",
        fontWeight: 700,
    },
    children: { display: "flex", flexDirection: "column", gap: "10px", paddingLeft: "16px", borderLeft: "3px solid #d7e1dc" },
};

export const screenStyles = {
    page: {
        minHeight: "100%",
        padding: "28px",
        background: "#F4F1EA",
        color: ENCRE,
    },
    layout: {
        maxWidth: "1080px",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        gap: "18px",
    },
    eyebrow: { margin: 0, color: GRIS, fontSize: "13px", fontWeight: 800, textTransform: "uppercase" },
    title: { margin: "4px 0 0", fontSize: "30px", color: PETROLE },
    searchBar: {
        display: "grid",
        gridTemplateColumns: "minmax(0, 1fr) auto",
        gap: "8px",
        alignItems: "center",
        padding: "12px",
        border: BORDER,
        borderRadius: "8px",
        background: "#ffffff",
    },
    searchInput: {
        minWidth: 0,
        minHeight: "38px",
        border: BORDER,
        borderRadius: "6px",
        padding: "8px 10px",
        color: ENCRE,
        fontSize: "14px",
        fontWeight: 700,
        outlineColor: VALIDATION,
    },
    clear: active => ({
        minHeight: "38px",
        padding: "8px 12px",
        borderRadius: "6px",
        border: `1px solid ${PETROLE}`,
        background: active ? "#ffffff" : "#eef3f0",
        color: active ? PETROLE : "#94a3b8",
        cursor: active ? "pointer" : "default",
        fontSize: "13px",
        fontWeight: 900,
        whiteSpace: "nowrap",
    }),
};
